export const apiFetchParams = {
  baseApiUrl: "",
};
